var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_700_4519",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_700_4519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_2",
    d: "M9.51922 15.6155C7.81154 15.6155 6.36539 15.0232 5.18079 13.8386C3.99618 12.6539 3.40387 11.2078 3.40387 9.50012C3.40387 7.79243 3.99618 6.34628 5.18079 5.16167C6.36539 3.97707 7.81154 3.38477 9.51922 3.38477C11.2269 3.38477 12.6731 3.97707 13.8577 5.16167C15.0423 6.34628 15.6346 7.79243 15.6346 9.50012C15.6346 10.2142 15.5147 10.8963 15.275 11.5463C15.0352 12.1963 14.7153 12.7616 14.3153 13.2424L20.0692 18.9963C20.2077 19.1347 20.2785 19.3088 20.2817 19.5184C20.2849 19.728 20.2141 19.9052 20.0692 20.0501C19.9243 20.195 19.7487 20.2674 19.5423 20.2674C19.3359 20.2674 19.1603 20.195 19.0154 20.0501L13.2615 14.2962C12.7615 14.7091 12.1865 15.0321 11.5365 15.2655C10.8865 15.4988 10.2141 15.6155 9.51922 15.6155ZM9.51922 14.1155C10.8077 14.1155 11.899 13.6684 12.7933 12.7742C13.6875 11.8799 14.1346 10.7886 14.1346 9.50012C14.1346 8.21165 13.6875 7.1203 12.7933 6.22607C11.899 5.33183 10.8077 4.88472 9.51922 4.88472C8.23075 4.88472 7.1394 5.33183 6.24517 6.22607C5.35095 7.1203 4.90384 8.21165 4.90384 9.50012C4.90384 10.7886 5.35095 11.8799 6.24517 12.7742C7.1394 13.6684 8.23075 14.1155 9.51922 14.1155Z",
    fill: "#1C1B1F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.05ab50f685a034d960b1df521754bb2d.svg";
export { ForwardRef as ReactComponent };